import { Middleware } from "@reduxjs/toolkit";
import { changeSetting, toggleSetting } from "store/reducers/settingsSlice";

const updateElementClass = (el: Element | null, stat: boolean, name: string) => el && el.classList[stat ? "add" : "remove"](name);
const updateBodyClass = (stat: boolean, name: string) => updateElementClass(document.body, stat, name);

export const updateClasses = (settings) => {
  updateBodyClass(settings.isFixed, "layout-fixed");
  updateBodyClass(settings.isBoxed, "layout-boxed");
  updateBodyClass(settings.isCollapsed, "aside-collapsed");
  updateBodyClass(settings.isCollapsedText, "aside-collapsed-text");
  updateBodyClass(settings.isFloat, "aside-float");
  updateBodyClass(settings.asideHover, "aside-hover");
  updateBodyClass(settings.offsidebarOpen, "offsidebar-open");
  updateBodyClass(settings.asideToggled, "aside-toggled");
  updateBodyClass(settings.horizontal, "layout-h");
  updateElementClass(document.querySelector(".sidebar"), settings.asideScrollbar, "show-scrollbar");
};

const settingsMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);
  if (toggleSetting.match(action) || changeSetting.match(action)) {
    updateClasses(store.getState().settings);
  }
  return result;
};

export default settingsMiddleware;
